import { useEffect, useRef, useState } from 'react'

function useComponentSize<T extends Element>({
  deps = [],
  matchParentElement = false,
}: { deps?: any[]; matchParentElement?: boolean } = {}) {
  const [size, setSize] = useState({ width: 0, height: 0 })
  const ref = useRef<T | null>(null)

  useEffect(() => {
    const element = matchParentElement ? ref?.current.parentElement : ref?.current
    const updateSize = () => {
      if (element) {
        const { width, height } = element?.getBoundingClientRect()
        setSize({ width, height })
      }
    }

    const resizeObserver = new ResizeObserver(updateSize)

    if (element) {
      updateSize()
      resizeObserver?.observe(element)
    }

    return () => {
      resizeObserver?.disconnect()
    }
  }, [ref, ...deps])

  return [ref, size] as const
}

export default useComponentSize
